module.exports = __webpack_public_path__ + "img/icon-chrome-512x512.0919d0c5.png";